
import index from '@/pages/index'
import { getopenid, initsj, getsessionkey } from '@/commonjs/commonfn.js'
import store from '@/store/'
export var routerattr = [{
    path: '/',
    name: 'index',
    component: index,
    beforeEnter: (to, from, next) => {
        store.commit('yujiazaiset', 1);
        initsj();
        getopenid();
        getsessionkey(next);

    }
}]


// WEBPACK FOOTER //
// ./src/router/index1.js